import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ChevronDownIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path clipRule="evenodd" d="M7.41 8L12 12.9447L16.59 8L18 9.52227L12 16L6 9.52227L7.41 8Z" fill="currentColor" fillRule="evenodd" />
    </svg>
  )
})
ChevronDownIcon.displayName = 'ChevronDownIcon'
export default ChevronDownIcon
